import register from '../../../../global/js/registry';
export default register('m-marker-image', () => import(/* webpackMode: "lazy" */ './m-marker-image.controller'));
